import React, {Component}               from "react";
import {ImageBackground, Text, View}    from "react-native";
import {connect}                        from "react-redux";
import Modal                            from "./Modal";
import NBButton                         from "../NBButton";
import * as Actions                     from "../../constants/Actions";
import styles                           from "../../styles/Styles";

class ModalHowToPlay extends Component {
    render() {
        // Titles
        var titles = [];
        titles.push(<Text style={styles.textModal}>Title Menu</Text>);
        titles.push(<Text style={styles.textModal}>Settings (All Modes)</Text>);
        titles.push(<Text style={styles.textModal}>Settings (Multiplayer)</Text>);
        titles.push(<Text style={styles.textModal}>Player Settings</Text>);
        titles.push(<Text style={styles.textModal}>Category Selection</Text>);
        titles.push(<Text style={styles.textModal}>Playing the Game (1/4)</Text>);
        titles.push(<Text style={styles.textModal}>Playing the Game (2/4)</Text>);
        titles.push(<Text style={styles.textModal}>Playing the Game (3/4)</Text>);
        titles.push(<Text style={styles.textModal}>Playing the Game (4/4)</Text>);
        titles.push(<Text style={styles.textModal}>Fun Tips</Text>);
        titles.push(<Text style={styles.textModal}>Contact Info</Text>);

        // Instructions
        var instructions = [];
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>Admit One starts a single player game</Text>
                <Text style={styles.textModal}>Group Rate starts a 2-4 player (or team) game</Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>Show Countdown: Start each round with a countdown</Text>
                <Text style={styles.textModal}>Play Sound Effects: Toggle sound effects</Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>
                    Share Screen: If the screen is being shared (ie on Twitch), prevents the answers from being displayed on screen.
                </Text>
                <Text style={styles.textModal}>Show Answers: Display the answer on screen for the host</Text>
                <Text style={styles.textModal}>Swipe Controls: Allows the host to swipe to assign points. Not available in the web version.</Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>
                    Here you can set the number of players and their names, and even take photos to display in game.
                </Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>
                    This screen allows you to select the list of movies you will play, such as American Film Institute Top 100 Lists or
                    Top 100 Box Office Lists.
                </Text>
                <Text style={styles.textModal}>The History button will allow you to check the results of each round played so far.</Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>
                    At the start of each round, you will be prompted to select a movie to play. The movie's title will be visible to
                    the host in multiplayer.
                </Text>
                <Text style={styles.textModal}>Intermission will return you to category selection.</Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>
                    The Play button will reveal the names of up to 10 actors from the movie. When all the actors have been revealed, it will
                    display additional information about the movie's release.
                </Text>
                <Text style={styles.textModal}>Eject will end the round without a winner.</Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>To submit a guess, select a movie using the dropdown on the left and press Submit.</Text>
                <Text style={styles.textModal}>Players score more points if they guess before all clues have been revealed.</Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>If swipe controls are enabled, points can be assigned after a correct guess is made.</Text>
                <Text style={styles.textModal}>
                    Otherwise, points will be assigned to the current player. To select a player, press Select or the player's icon. Make sure
                    to do this before submitting the guess!
                </Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>You can experiment by playing with a dedicated host or swapping hosts each round.</Text>
                <Text style={styles.textModal}>
                    If a guess is made that isn't on the list, you can either tell the guesser or substitute a known wrong answer without
                    revealing this to the player.
                </Text>
            </View>
        );
        instructions.push(
            <View style={styles.viewHowToPlay}>
                <Text style={styles.textModal}>
                    If you wish to provide feedback or encounter any bugs, please feel free to contact me at andrew.marrell@gmail.com
                </Text>
            </View>
        );

        // Buttons
        var back = null, next = null;
        if (this.props.indexHowToPlay > 0) {
            back = <NBButton key={0} icon={"arrow-back"} iconFamily={"Ionicons"} iconType={"iconLeft"} onPress={() => {this.props.switchHowToPlay(-1)}} text={"Back"} />;
        }
        if (this.props.indexHowToPlay < instructions.length - 1) {
            next = <NBButton key={1} icon={"arrow-forward"} iconFamily={"Ionicons"} iconType={"iconRight"} onPress={() => {this.props.switchHowToPlay(1)}} text={"Next"} />;
        }

        var close = <NBButton key={2} onPress={() => {this.props.dismissHowToPlay()}} text={"x"} />; 
        var buttons = [back, close, next];

        return (
           <View>
                <Modal animationType={"fade"} onRequestClose={null} supportedOrientations={["landscape"]} transparent={true}
                    visible={this.props.showHowToPlay}>
                    {/* Modal Background is a hack to dim the screen behind the modal */}
                    <View style={styles.modalBackground}>
                        <View style={styles.modalDialog}>
                            <ImageBackground source={require("../../../assets/clapboard_temp.png")} style={styles.backgroundModal} imageStyle={styles.backgroundImageStretch}>
                                <View style={styles.modalDialogInner}>
                                    {/* Titles */}
                                    {titles[this.props.indexHowToPlay]}
                                    <View style={styles.lineHorizontalModal} />

                                    {/* Instructions */}
                                    {instructions[this.props.indexHowToPlay]}
                                    
                                    <View style={styles.lineHorizontalModal} />
                                    <View style={styles.menuHorz}>
                                        {buttons}
                                    </View>
                                </View>
                            </ImageBackground>
                        </View>
                    </View>
                </Modal>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        indexHowToPlay: state.indexHowToPlay,
        showHowToPlay:  state.showHowToPlay
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        dismissHowToPlay:   ()      => { dispatch({type: Actions.SHOW_HOW_TO_PLAY}) },
        switchHowToPlay:    (value) => { dispatch({type: Actions.SWITCH_HOW_TO_PLAY, value: value}) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalHowToPlay);